//Import external libraries
import React, {ReactNode} from 'react';
import {NavItem, NavLink, Button} from 'reactstrap';
import Config from './../../Config';

//Import Episerver Components
import CmsComponent from '@episerver/spa-core/Components/CmsComponent';
import EpiComponent from '@episerver/spa-core/EpiComponent';

import MenuItemBlockData from 'app/Models/Content/MenuItemBlockData';

interface MenuItemBlockState {
  linkTarget: string;
  show: boolean;
}

export default class MenuItemBlock extends EpiComponent<MenuItemBlockData, MenuItemBlockState> {
  protected getInitialState(): MenuItemBlockState {
    return {
      linkTarget: this.props.data.link.value !== null ? this.props.data.link.value : '#',
      show: false,
    };
  }

  public componentDidUpdate() {
    let newLinkTarget: string = this.props.data.link.value !== null ? this.props.data.link.value : '#';
    if (this.state.linkTarget !== newLinkTarget) {
      this.setState({
        linkTarget: this.props.data.link.value !== null ? this.props.data.link.value : '#',
      });
    }
  }

  public onButtonClick(event: MouseEvent) {
    this.navigateTo(this.props.data.buttonLink.value);
    event.preventDefault();
    return false;
  }

  public render(): ReactNode {
    const currentPath = this.props.context.getStore().getState()?.ViewContext?.currentPath;
    const isSelected = this.state.linkTarget == currentPath;

    // if (this.props.data.menuImage.value !== null) {
    let dropdownButton: ReactNode = null;
    if (this.props.data.buttonLink.value !== null && this.props.data.buttonText.value !== null) {
      dropdownButton = (
        <Button color='primary' size='lg' block onClick={this.onButtonClick.bind(this)}>
          {this.props.data.buttonText.value}
        </Button>
      );
    }
    return (
      <NavItem>
        <div className={`__menu-item-container ${isSelected ? 'selected' : ''}`}>
          <div className='__title-text'>
            <NavLink
              style={{
                backgroundImage: this.props.data.menuImage?.value
                  ? `url(${Config.epiBaseUrl + this.props.data.menuImage?.value?.url})`
                  : '',
              }}
              href={this.state.linkTarget}
              active={this.state.linkTarget == this.props.path}
              eventkey={this.props.data.name}
              arial-label={this.props.data.ariaLabelText?.value}>
              <span className={`${this.props.data.menuImage?.value ? 'item-with-image' : ''}`}>{this.props.data.name.value}</span>
            </NavLink>
          </div>
        </div>
      </NavItem>
    );
  }
}
